import AsyncStorage from "@react-native-community/async-storage";
import React, { useEffect, useState } from "react";
import { View, Text, ImageBackground, ScrollView, Image, TouchableOpacity, Dimensions } from "react-native";

import Menu from "../../menu"
import style from "./style";
import XarxesSocials from "../../PopUps/xarxesSocials";
import api from "../../config/api_urls";

function PrefilMulti(RouterData) {
        
    const [nom, setNom] = useState("");
    const [punts, setPunts] = useState(0) 
    const [token, setToken] = useState("");
    const [statsItineraris, setStatsItineraris] = useState([]);

    async function getPointsItinerari(DataItineraris) {
        let items = []
        let itinerarisFinalitzat = 0;
    
        await DataItineraris.map(itinerari => {
            AsyncStorage.getItem("itinerari" + itinerari.id).then( value => {
                if(value)
                {
                    value = JSON.parse(value);
                    if(value.finalitzat)
                    {
                        items.push({itinerari: itinerari.id , estat : 'finalitzat', punts: value.puntsTotals ,
                        Nom : itinerari.Nom,
                        Nom_ES : itinerari.Nom_ES,
                        Nom_EN : itinerari.Nom_EN,
                        showSuperPremi : true});
                        itinerarisFinalitzat = 1 + itinerarisFinalitzat ;
                    }else
                    {
                        items.push({itinerari: itinerari.id , estat : 'comencat', punts: value.puntsTotals , pois : value.pois ,
                         Nom : itinerari.Nom,
                         Nom_ES : itinerari.Nom_ES,
                         Nom_EN : itinerari.Nom_EN,
                         showSuperPremi : true }); //showSuperPremi : true
                    }
                }else
                {
                    items.push({itinerari : itinerari.id , estat : 'no visitat' ,
                    Nom : itinerari.Nom,
                    Nom_ES : itinerari.Nom_ES,
                    Nom_EN : itinerari.Nom_EN,
                })
                }
            })
        });
        
        return { itineraris: items , itinerarisFinalitzat: itinerarisFinalitzat };
    }

    useEffect(() => {
        
        getPointsItinerari( RouterData.route.params.projecte.pagines).then(data => {
            setStatsItineraris(data);
        }).catch(err => {
            console.log(err);
        })
    
        AsyncStorage.getItem("nom").then(nom => {
            if(nom)
            {
                setNom(nom);
            }
        });
        AsyncStorage.getItem("puntsTotals").then(punts => {
            if(punts)
            {
                setPunts(punts);
            }
        });
        AsyncStorage.getItem("token").then(token => {
            if(token)
            {
                setToken(token);
            }
        });

    },[]);

    const navigateImatges = (itinerari) => {
        let statsPressedItinerari  = statsItineraris.itineraris.find(e => e.itinerari == itinerari.id);
        RouterData.navigation.navigate("ImatgesPerfilItinerari",{...RouterData.route.params, perfilImatges: statsPressedItinerari});
    }

    const renderItineraris = () => {

        let items = []
        RouterData.route.params.itineraris.map((itinerari, index) => {

            let color = "#2c9f26"
            if(statsItineraris.itineraris){
                if(statsItineraris.itineraris[index]?.estat == "finalitzat")
                {
                    color = "#9f2c26"
                    
                }else if(statsItineraris.itineraris[index]?.estat == 'comencat')
                {
                    color = "#c7bf18"
                }
            }

            items.push(
            <TouchableOpacity style={style.botoItinerari} key={index} onPress={()=>{navigateImatges(itinerari)}}>
                <View style={[style.itinerariContainer,{backgroundColor : color}]}>
                    <Text style={{fontSize: 14, fontWeight: 'bold', padding: 5}}>
                        <Text style={[style.itinerariText]}>{itinerari['Nom'] ? itinerari['Nom'+RouterData.route.params.idioma].toUpperCase() : null}</Text>
                    </Text>
                </View>
            </TouchableOpacity>
            )
        })
        return items
    }


    return (
        <View style={{ flex: 1 }}>
          <ImageBackground source={this.state.projecte['FonsPantalla7'+this.state.idioma] ? { uri: api.api_url + this.state.projecte['FonsPantalla7'+this.state.idioma].url } : null} style={style.imageBackground}>
                    {/* Box Perfil (NOM) */}
                    <View style={{flex:20,justifyContent:'center',alignItems:'center'}}>
                        <View style={style.boxNom}>
                            <Text style={style.textPerfil}>{RouterData.route.params.recursos.find(e => e.tipus_recurs === 'perfil_nom')['text_recurs' + RouterData.route.params.idioma]}</Text>
                            <Text style={style.nom}>{nom}</Text>
                        </View>
                    </View>
                    {/* Box Perfil (PUNTS) */}
                    <View style={{flex:15,display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: 'center'}}>
                        <View style={{width: "40%", height: "90%", justifyContent: "center"}}>
                            <View style={{alignSelf: 'center', backgroundColor: "#f7f4d3", alignItems: "center", justifyContent: "center", width: "90%", height: "100%"}}>
                                <Text style={style.SecondTitle}>{RouterData.route.params.recursos.find(e => e.tipus_recurs === 'perfil_punts_totals')['text_recurs' + RouterData.route.params.idioma]}</Text>
                                <Text style={style.SecondText}>{punts}</Text>
                            </View>
                            
                        </View>
                        <View style={{width: "40%", height: "90%", justifyContent: "center"}}>
                            <View style={{alignSelf: 'center', width: "90%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: "#f7f4d3"}}>
                                <Text style={style.SecondTitle}>{RouterData.route.params.recursos.find(e => e.tipus_recurs === 'perfil_punts_itineraris')['text_recurs' + RouterData.route.params.idioma]}</Text>
                                <Text style={style.SecondText}>{statsItineraris.itinerarisFinalitzat}/{RouterData.route.params.itineraris.length}</Text>
                            </View>
                        </View>
                    </View>

                    {/* Itineraris */}
                    <View style={{flex:45,alignItems:'center',justifyContent:'center',width:'100%',alignItems: "center", justifyContent: "center",flexDirection:'row'}}>
                        
                        <ScrollView style={style.caixa}>
                            <View style={{
                                justifyContent: 'center',
                                flexGrow: 0,
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap'
                            }}>
                                {renderItineraris()}
                            </View>
                        </ScrollView>
                    </View>

                    {/* Compartir xarxes */}
                    <View style={{flex:10,justifyContent:'center',alignItems:'center'}}>
                        <View style={{flex:1,justifyContent:'center',alignItems:'center',flexDirection:'row'}}>
                            <TouchableOpacity style={{height: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.11, width: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.11}} onPress={
                            ()=>{RouterData.navigation.navigate('Credits',RouterData.route.params)}}>
                                <Image style={{width:'100%',height: "90%",alignSelf:'center',resizeMode:'contain'}} source={{uri: api.api_url + RouterData.route.params.recursos.find(e=> e.tipus_recurs == "perfil_contacte")["imatge_recurs"].url}} />    
                            </TouchableOpacity>
                            {XarxesSocials(RouterData,token,{textSocial : encodeURI(RouterData.route.params.projecte['textSocial'+RouterData.route.params.idioma]).replaceAll('#', '%23'), peticio : "Global" })}
                        </View>
                    </View>
                    {/* Menu */}
                    <View style={{flex:10}}>
                        {Menu(RouterData)}
                    </View>
                </ImageBackground>
        </View>
    )
}

export default PrefilMulti;